import { IonRouterOutlet } from '@ionic/react'
import { useGate, useStore } from 'effector-react'
import { ReactNode } from 'react'
import { Outlet } from 'react-router-dom'
import { CarVehicleCategoryDrawer } from '~/widgets/CarVehicleCategoryDrawer'
import { Documents } from '~/widgets/Documents'
import { LocalNotifications } from '~/widgets/Notifications'
import { Penalties } from '~/widgets/Penalties'
import { Profile } from '~/widgets/Profile'
import { Proposal, proposalModel } from '~/widgets/Proposal'
import { Support } from '~/widgets/Support'
import { driverModel } from '~/entities/Driver'
import { driverEmailModel } from '~/entities/DriverEmail'
import { mainBalance } from '~/entities/MainBalance'
import { okoDriveModel } from '~/entities/OkoDrive'
import { LeadWelcomeDrawer } from '~/entities/Registration'
import { rentalContractModel } from '~/entities/RentalContract'
import { ProgressBlock } from '~/shared/ui/Loaders'
import { MAIN_LAYOUT_MENU_ID } from '~/shared/ui/theme/theme'
import { Menu } from './Menu'

type Props = {
  children?: ReactNode
}

export function MainLayout({ children }: Props) {
  useGate(rentalContractModel.Gate)
  useGate(proposalModel.Gate)
  useGate(mainBalance.Gate)
  useGate(driverEmailModel.Gate)
  useGate(okoDriveModel.Gate)

  const acceptanceNeedPending = useStore(proposalModel.$acceptanceNeedPending)
  const driverPending = useStore(driverModel.$driverPending)

  if (acceptanceNeedPending || driverPending) {
    return (
      <div
        style={{
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <ProgressBlock />
      </div>
    )
  }

  return (
    <>
      <Menu />
      <IonRouterOutlet id={MAIN_LAYOUT_MENU_ID}>
        {children || <Outlet />}
      </IonRouterOutlet>
      <Proposal />
      <Profile />
      <Penalties />
      <LocalNotifications />
      <Support />
      <Documents />
      <CarVehicleCategoryDrawer />
      <LeadWelcomeDrawer />
    </>
  )
}
